import { useEffect } from 'react'

// Zoom mínimo al hacer click en un árbol: acerca solo si el usuario está más
// lejos; si ya está más cerca, conserva su zoom ("acercar solo si está lejos").
const POPUP_MIN_ZOOM = 18.5

/**
 * Vuela reactivamente al árbol seleccionado cada vez que se abre
 * o cambia el popup (popupLngLat).
 * El zoom final es al menos 18.5; se conserva un zoom mayor si el usuario
 * ya estaba más cerca.
 */
export const useFlyToPopup = (map, mapLoaded, popupLngLat) => {
  useEffect(() => {
    if (!map || !mapLoaded || !popupLngLat) return
    const [lng, lat] = popupLngLat
    const currentZoom = map.getZoom()
    // Desplazar el árbol hacia el borde inferior: offset positivo en Y
    // mueve el centro del mapa hacia arriba, dejando el árbol en el tercio inferior
    const offsetY = map.getContainer().offsetHeight * 0.28
    map.flyTo({
      center: [lng, lat],
      zoom: Math.max(currentZoom, POPUP_MIN_ZOOM),
      pitch: 60,
      duration: 800,
      essential: true,
      offset: [0, offsetY],
    })
  }, [popupLngLat, map, mapLoaded])
}
